import React from 'react'
import PropTypes from 'prop-types'

import ItemWrapper from 'components/digitalTemplates/ItemWrapper'

const mapItems = (section, itemEntities) => {
  if (section.items && itemEntities){
    return section.items.map(itemId => itemEntities[itemId] || {})
  }

  return section.items || []
}

const wrapItems = (availableComponents, items, options = {}) => items.map((item) => {
  const Component = item ? availableComponents[item.item_type] : null
  if (Component){
    const {
      callbacks, forwardContextToItems, itemEntities, renderNested, selectedItem,
    } = options

    const { selectItemCallback } = callbacks || {}
    const selectObject = { type: 'digitalTemplatePageItem', id: item.id }

    if (renderNested){
      return (
        <ItemWrapper
          key={item.id}
          item={item}
          itemEntities={itemEntities}
          render={({ nestedItems }) => (
            <Component
              callbacks={callbacks}
              context={forwardContextToItems}
              entityType="digitalTemplatePageItem"
              itemEntities={itemEntities}
              isSelected={selectedItem.id === item.id}
              onClick={selectItemCallback ? e => selectItemCallback(selectObject, e) : null}
              selectedItem={selectedItem}
              {...item}
            >
              {wrapItems(availableComponents, nestedItems, options)}
            </Component>
          )}
        />
      )
    }

    return (
      <Component
        key={item.id}
        entityType="digitalTemplatePageItem"
        entityId={item.id}
        isSelected={selectedItem.id === item.id}
        onClick={selectItemCallback ? e => selectItemCallback(selectObject, e) : null}
        {...item}
      />
    )
  }

  return null
})

const ContentWrapper = (props) => {
  const {
    availableComponents,
    callbacks,
    itemEntities,
    forwardContextToItems,
    render,
    renderNested,
    section,
    selectedItem,
  } = props

  const itemArray = mapItems(section, itemEntities)

  return render({
    items: itemArray,
    itemComponents: wrapItems(availableComponents, itemArray, {
      callbacks,
      forwardContextToItems,
      itemEntities,
      renderNested,
      selectedItem,
    }),
  })
}

ContentWrapper.propTypes = {
  availableComponents: PropTypes.object.isRequired,
  callbacks: PropTypes.object,
  forwardContextToItems: PropTypes.object,
  render: PropTypes.func.isRequired,
  renderNested: PropTypes.bool,
  section: PropTypes.object.isRequired,
  selectedItem: PropTypes.object,
}

ContentWrapper.defaultProps = {
  callbacks: {},
  renderNested: false,
  selectedItem: {},
}

export default ContentWrapper
